import { useMemo, useRef, useEffect, useState, createRef } from "react";
//import NextImage from "../../elements/image"
import { Loader, LoaderStatus } from "@googlemaps/js-api-loader";
//import { GoogleMap, useLoadScript } from '@react-google-maps/api';
import RetailerCard from "../../elements/retailer-card";
import { Map, Marker } from '@vis.gl/react-google-maps';

const RETAILERS_LOCATIONS = [
  {
    name: "Ballinger Village Thriftway",
    lat: 47.7769, lng: -122.3086,
    address: "20150 Ballinger Way NE, Shoreline, WA 98155",
    url: "https://example.com/ballinger-thriftway"
  },
  {
    name: "The Sunflower Boutique",
    lat: 47.8101, lng: -122.3774,
    address: "123 5th Ave S, Edmonds, WA 98020",
    url: "https://example.com/sunflower-boutique"
  },
  {
    name: "The Sugar Rush",
    lat: 47.7610, lng: -122.2056,
    address: "101 Main St, Bothell, WA 98011",
    url: "https://example.com/the-sugar-rush"
  },
  {
    name: "Cone & Steiner",
    lat: 47.59832, lng: -122.33255,
    address: "135 S King St., Seattle, WA 98104",
    url: "https://example.com/cone-and-steiner"
  },
  {
    name: "Treasure & Teas",
    lat: 47.810397, lng: -122.377736,
    address: "102 5th Ave. S., Edmonds, WA 98020",
    url: "https://www.treasuresandteas.com"
  }
];


const Retailers = ({ data }) => {

  const [selectedRetailer, setSelectedRetailer] = useState(null);

  const cardRefs = useMemo(() => {
    const m = {};
    for (const retailer of data.retailers) {
      m[retailer.name] = createRef();
    }
    return m;
  }, [data.retailers]);

  // const flash = () => {
  //   if (selectedRetailer) {
  //     const card = cardRefs.current.get(selectedRetailer);
  //     if (card) {
  //       card.scrollIntoView({ behavior: "smooth", block: "center" });
  //       card.classList.add("flash");
  //       setTimeout(() => card.classList.remove("flash"), 600);
  //     }
  //   }
  // };

  useEffect(() => {
    if (!selectedRetailer) return;
    const ref = cardRefs[selectedRetailer.name];
    ref?.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [selectedRetailer, cardRefs]);

  return (
    <div className=" max-w-3xl mx-auto">
      <h2 className="text-3xl text-crimson ">{data.title}</h2>

      <div className="flex flex-row h-screen gap-6">
        <section className="w-2/5 h-full overflow-y-auto">
          <ul className="not-prose grid gap-3">
            {data.retailers.map((r) => (
              <RetailerCard key={r.name} 
                            ref={cardRefs[r.name]} 
                            {...r} 
                            isSelected={selectedRetailer === r.name}
                            onClick={() => setSelectedRetailer(r)} />
            ))}
          </ul>
        </section>
        {/* 
      <section className="max-w-3xl mx-auto p-6" id="map"> */}
        <section className="flex-1 h-full relative" id="map">
          <Map
            style={{ width: '100%', height: '100%' }}
            defaultCenter={{ lat: 47.7704, lng: -122.2772 }}
            defaultZoom={12}
            gestureHandling={'greedy'}
            disableDefaultUI={true}
          />
          {RETAILERS_LOCATIONS.map((location) => (
            <Marker key={location.name} 
                    position={{ lat: location.lat, lng: location.lng }} 
                    onClick={() => setSelectedRetailer(data.retailers.find(r => r.name === location.name))}>
            </Marker>
          ))}
          <p className="text-sm text-gray-600 mt-2">Tap a marker for address and website.</p>
        </section>

      </div>
    </div>
  )
}

export default Retailers

